<script lang="ts">
import {Options, Vue} from "vue-class-component";
@Options({
  data() {
    return {
      snackbar: false,
      snackbarText: "",
    };
  },
  methods: {
    onGoToFacebookClick(): void {
      window.location.href = 'https://www.facebook.com/kreativhimzokucko';
    },
    addToClipboard(text: string): void {
      if (!navigator.clipboard) {
        this.snackbar = true;
        this.snackbarText = "Nem sikerült a vágólapra másolás! Nem biztonságos kapcsolat"
        return;
      }
      navigator.clipboard.writeText(text).then(() => {
        this.snackbar = true;
        this.snackbarText = "Vágólapra másolva!"
      }, (err) => {
        this.snackbar = true;
        this.snackbarText = "Nem sikerült a vágólapra másolás! " + err.message
      });
    }
  }
})
export default class ConnectionRow extends Vue {

}
</script>

<template>
  <v-snackbar
      v-model="snackbar"
      timeout="2000"
  >{{snackbarText}}</v-snackbar>
  <v-row class="mt-5 mx-auto mb-5 playFairFont" align="center" justify="center" style="width: 60%">
    <v-col>
      <v-card
          variant="text"
          class="mx-auto" max-width="200"
          width="200"
          href="mailto:info@himzokucko.hu"
          style="text-align: center"
          height="200"
          elevation="5"
      >
        <v-icon
            icon="mdi-gmail"
            color="green"
            size="70"
        >
        </v-icon>

        <v-card-title>
          <div style="text-align: center" class="font-weight-bold ms-1 mb-2">MAIL</div>
        </v-card-title>
        <v-card-text>
          info@himzokucko.hu
        </v-card-text>
      </v-card>
    </v-col>
    <v-col>
      <v-card
          variant="text"
          class="mx-auto"
          max-width="200"
          width="200"
          size="70"
          href="tel:+36 30 5705 139"
          style="text-align: center"
          height="200"
          elevation="5"
      >
        <v-icon
            icon="mdi-phone"
            color="orange"
            size="70"
        >
        </v-icon>

        <v-card-title>
          <div style="text-align: center" class="font-weight-bold ms-1 mb-2">Mobil</div>
        </v-card-title>
        <v-card-text>
          +36 30 5705 139
        </v-card-text>
      </v-card>
    </v-col>
    <v-col>
      <v-card
          variant="text"
          class="mx-auto"
          max-width="200"
          width="200"
          link
          @click="onGoToFacebookClick"
          style="text-align: center"
          height="200"
          elevation="5"
      >
        <v-icon
            icon="mdi-facebook"
            color="blue"
            size="70"
        >
        </v-icon>
        <v-card-title>
          <div style="text-align: center" class="font-weight-bold ms-1 mb-2">Facebook</div>
        </v-card-title>
        <v-card-text>
          www.facebook.com/<br>kreativhimzokucko
        </v-card-text>
      </v-card>
    </v-col>
    <v-col>
      <v-card style="text-align: center"
              variant="text"
              class="mx-auto"
              max-width="200"
              width="200"
              height="200"
              href="http://maps.google.com/?q=6100 Kiskunfélegyháza Róna utca 17, Magyarország"
              elevation="5"
      >
        <v-icon
            icon="mdi-map-marker"
            color="red"
            size="70"
        >
        </v-icon>

        <v-card-title>
          <div style="text-align: center" class="font-weight-bold ms-1 mb-2">Telephely</div>
        </v-card-title>
        <v-card-text style="text-align: center">
          6100 Kiskunfélegyháza, Róna utca 17.
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<style scoped>

</style>